var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { MenuTypes, RailwayTargetTypes } from '@/models/Menu/Constants';
import { TargetAreaTypes } from '@/models/CampaignOperation/Constants';
export default (function (menuSetting, isCampaignCreative, menuType) {
    switch (menuType) {
        case MenuTypes.Geo:
            return convertFromGeoMenuSetting(menuSetting, isCampaignCreative);
        case MenuTypes.Newspaper:
            return convertFromNewspaperMenuSetting(menuSetting);
        case MenuTypes.Pta:
            return convertFromPtaMenuSetting(menuSetting);
        case MenuTypes.Automobile:
            return convertFromAutomobileMenuSetting(menuSetting);
        case MenuTypes.Mansion:
            return convertFromMansionMenuSetting(menuSetting);
        case MenuTypes.GeoGenome:
            return convertFromGeoGenomeMenuSetting(menuSetting);
        case MenuTypes.Railway:
            return convertFromRailwayMenuSetting(menuSetting);
        case MenuTypes.Retargeting:
            return convertFromRetargetingMenuSetting(menuSetting);
        case MenuTypes.CustomGeo:
            return convertFromCustomGeoMenuSetting(menuSetting);
        case MenuTypes.Office:
            return convertFromOfficeMenuSetting(menuSetting);
        case MenuTypes.Custom:
            return convertFromCustomMenuSetting(menuSetting);
        default:
            return convertFromGeoMenuSetting(menuSetting, isCampaignCreative);
    }
});
var convertFromGeoMenuSetting = function (menuSetting, isCampaignCreative) {
    var id = menuSetting.id, target = menuSetting.target, minutesAgo = menuSetting.minutesAgo, visitCount = menuSetting.visitCount, enableRadiusAutomation = menuSetting.enableRadiusAutomation, useLowQualityLocation = menuSetting.useLowQualityLocation, radius = menuSetting.radius, enableBulkSetting = menuSetting.enableBulkSetting, deliveryLocationGroups = menuSetting.deliveryLocationGroups;
    return {
        id: id,
        target: target,
        minutesAgo: minutesAgo,
        visitCount: visitCount,
        enableRadiusAutomation: enableRadiusAutomation,
        useLowQualityLocation: useLowQualityLocation,
        radius: radius,
        enableBulkSetting: enableBulkSetting,
        deliveryLocationGroups: deliveryLocationGroups
            .map(function (group) {
            return convertFromDeliveryLocationGroup(group, isCampaignCreative);
        })
            .filter(function (group) { return group != null; }),
    };
};
var convertFromNewspaperMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var subscriptionRate = orderDescription.subscriptionRate, conditions = orderDescription.conditions, administrativeDistrictType = orderDescription.administrativeDistrictType, area = orderDescription.area, splitGroup = orderDescription.splitGroup, memo = orderDescription.memo;
    return {
        id: id,
        orderDescription: {
            subscriptionRate: subscriptionRate,
            conditions: conditions,
            administrativeDistrictType: administrativeDistrictType,
            area: convertArea(administrativeDistrictType, area),
            splitGroup: splitGroup,
            memo: memo,
        },
    };
};
var convertFromPtaMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var targetAges = orderDescription.targetAges, administrativeDistrictType = orderDescription.administrativeDistrictType, area = orderDescription.area, splitGroup = orderDescription.splitGroup, memo = orderDescription.memo;
    return {
        id: id,
        orderDescription: {
            targetAges: targetAges,
            administrativeDistrictType: administrativeDistrictType,
            area: convertArea(administrativeDistrictType, area),
            splitGroup: splitGroup,
            memo: memo,
        },
    };
};
var convertFromAutomobileMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var extractionCondition = orderDescription.extractionCondition, targetCarType = orderDescription.targetCarType, targetBrandOrCarName = orderDescription.targetBrandOrCarName, targetDomesticImportedCarClassification = orderDescription.targetDomesticImportedCarClassification, targetFirstRegistrationYearMonth = orderDescription.targetFirstRegistrationYearMonth, targetVehicleInspectionExpiration = orderDescription.targetVehicleInspectionExpiration, targetMileage = orderDescription.targetMileage, administrativeDistrictType = orderDescription.administrativeDistrictType, area = orderDescription.area, splitGroup = orderDescription.splitGroup, memo = orderDescription.memo;
    var returnObj = {
        id: id,
        orderDescription: {
            extractionCondition: extractionCondition,
            target: {},
            administrativeDistrictType: administrativeDistrictType,
            area: convertArea(administrativeDistrictType, area),
            splitGroup: splitGroup,
            memo: memo,
        },
    };
    switch (extractionCondition) {
        case 'car_type':
            if (targetCarType) {
                returnObj.orderDescription.target = targetCarType;
            }
            break;
        case 'domestic_imported_car_classification':
            if (targetDomesticImportedCarClassification) {
                returnObj.orderDescription.target = targetDomesticImportedCarClassification;
            }
            break;
        case 'brand_or_car_name':
            if (targetBrandOrCarName) {
                returnObj.orderDescription.target = {
                    brandNames: targetBrandOrCarName.brandNames,
                };
            }
            break;
        case 'first_registration_year_month':
            if (targetFirstRegistrationYearMonth) {
                returnObj.orderDescription.target = targetFirstRegistrationYearMonth;
            }
            break;
        case 'vehicle_inspection_expiration':
            if (targetVehicleInspectionExpiration) {
                returnObj.orderDescription.target = targetVehicleInspectionExpiration;
            }
            break;
        case 'mileage':
            if (targetMileage) {
                returnObj.orderDescription.target = targetMileage;
            }
            break;
    }
    return returnObj;
};
var convertFromMansionMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var priceTarget = orderDescription.priceTarget, floorTarget = orderDescription.floorTarget, ageBuilt = orderDescription.ageBuilt, floorPlan = orderDescription.floorPlan, administrativeDistrictType = orderDescription.administrativeDistrictType, area = orderDescription.area, splitGroup = orderDescription.splitGroup, memo = orderDescription.memo, isValidPriceTarget = orderDescription.isValidPriceTarget, isValidFloorTarget = orderDescription.isValidFloorTarget, isValidAgeBuilt = orderDescription.isValidAgeBuilt, isValidFloorPlan = orderDescription.isValidFloorPlan;
    return {
        id: id,
        orderDescription: {
            priceTarget: isValidPriceTarget ? priceTarget : {},
            floorTarget: isValidFloorTarget ? floorTarget : {},
            ageBuilt: isValidAgeBuilt ? ageBuilt : {},
            floorPlan: isValidFloorPlan ? floorPlan : {},
            administrativeDistrictType: administrativeDistrictType,
            area: convertArea(administrativeDistrictType, area),
            splitGroup: splitGroup,
            memo: memo,
        },
    };
};
var convertFromGeoGenomeMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var clusterIds = orderDescription.clusterIds, prefecture = orderDescription.prefecture, memo = orderDescription.memo;
    return {
        id: id,
        orderDescription: {
            clusterIds: clusterIds,
            prefecture: prefecture,
            memo: memo,
        },
    };
};
var convertFromCustomMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription, uploadFile = menuSetting.uploadFile;
    var memo = orderDescription.memo;
    return {
        id: id,
        orderDescription: {
            memo: memo,
        },
        uploadFile: uploadFile,
    };
};
var convertFromRailwayMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var targetTypes = orderDescription.targetTypes, target = orderDescription.target, memo = orderDescription.memo;
    var railwayLineTargetObj = target.railwayLineTargetObj, railwayStationTargetObj = target.railwayStationTargetObj;
    var returnTarget = {};
    if (targetTypes.includes(RailwayTargetTypes.Station)) {
        var returnRailwayCompanies = railwayStationTargetObj.railwayCompanies.map(function (company) {
            var returnRailwayLines = company.railwayLines.map(function (line) {
                var stationIds = line.stationIdAndNames.map(function (idAndName) { return idAndName.stationId; });
                return {
                    id: line.id,
                    stationIds: stationIds,
                    radius: line.radius,
                };
            });
            return __assign(__assign({}, company), { railwayLines: returnRailwayLines });
        });
        returnTarget = {
            railwayStationTargetObj: __assign(__assign({}, railwayStationTargetObj), { railwayCompanies: returnRailwayCompanies }),
        };
    }
    else if (targetTypes.includes(RailwayTargetTypes.Commuting) ||
        targetTypes.includes(RailwayTargetTypes.Passenger)) {
        var railwayCompanies = railwayLineTargetObj.railwayCompanies.map(function (company) {
            var railwayLineIds = company.railwayLineIdAndNames.map(function (idAndName) { return idAndName.railwayLineId; });
            return {
                railwayCompanyId: company.railwayCompanyId,
                railwayLineIds: railwayLineIds,
            };
        });
        returnTarget = {
            railwayLineTargetObj: __assign(__assign({}, railwayLineTargetObj), { railwayCompanies: railwayCompanies }),
        };
    }
    return {
        id: id,
        orderDescription: {
            targetTypes: targetTypes,
            target: returnTarget,
            memo: memo,
        },
    };
};
var convertFromRetargetingMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var tags = orderDescription.tags, email = orderDescription.email, memo = orderDescription.memo;
    return {
        id: id,
        orderDescription: {
            tags: tags,
            email: email,
            memo: memo,
        },
    };
};
var convertFromCustomGeoMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var target = orderDescription.target, minutesAgo = orderDescription.minutesAgo, visitCount = orderDescription.visitCount, useS2 = orderDescription.useS2, memo = orderDescription.memo;
    return {
        id: id,
        orderDescription: {
            target: target,
            minutesAgo: minutesAgo,
            visitCount: visitCount,
            useS2: useS2,
            memo: memo,
        },
    };
};
var convertFromOfficeMenuSetting = function (menuSetting) {
    var id = menuSetting.id, orderDescription = menuSetting.orderDescription;
    var industryClassificationTargets = orderDescription.industryClassificationTargets, listingCategoryClassificationTarget = orderDescription.listingCategoryClassificationTarget, employeesTarget = orderDescription.employeesTarget, salesAmountTarget = orderDescription.salesAmountTarget, administrativeDistrictType = orderDescription.administrativeDistrictType, area = orderDescription.area, splitGroup = orderDescription.splitGroup, memo = orderDescription.memo, isValidIndustryClassification = orderDescription.isValidIndustryClassification, isValidListingCategoryClassification = orderDescription.isValidListingCategoryClassification, isValidEmployees = orderDescription.isValidEmployees, isValidSalesAmount = orderDescription.isValidSalesAmount;
    var returnIndustryClassificationTargets = [];
    if (isValidIndustryClassification) {
        returnIndustryClassificationTargets = industryClassificationTargets.map(function (target) {
            return {
                industryClassificationCodes: target.industryClassificationCodes,
                sectorCode: target.sectorCode,
            };
        });
    }
    var returnListingCategoryClassificationTarget = {
        listingCategoryClassificationTargets: isValidListingCategoryClassification
            ? listingCategoryClassificationTarget.listingCategoryClassificationTargets
            : [],
    };
    return {
        id: id,
        orderDescription: {
            industryClassificationTargets: returnIndustryClassificationTargets,
            listingCategoryClassificationTarget: returnListingCategoryClassificationTarget,
            employeesTarget: isValidEmployees ? employeesTarget : {},
            salesAmountTarget: isValidSalesAmount ? salesAmountTarget : {},
            administrativeDistrictType: administrativeDistrictType,
            area: convertArea(administrativeDistrictType, area),
            splitGroup: splitGroup,
            memo: memo,
            isValidIndustryClassification: isValidIndustryClassification,
            isValidListingCategoryClassification: isValidListingCategoryClassification,
            isValidEmployees: isValidEmployees,
            isValidSalesAmount: isValidSalesAmount,
        },
    };
};
var convertArea = function (administrativeDistrictType, area) {
    var prefectureAreaObj = area.prefectureAreaObj, cityAreaObj = area.cityAreaObj;
    if (administrativeDistrictType === TargetAreaTypes.PREFECTURE) {
        return {
            prefectureAreaObj: {
                countryId: prefectureAreaObj.countryId,
                prefectureIds: prefectureAreaObj.prefectureIds,
            },
        };
    }
    else {
        return {
            cityAreaObj: {
                countryId: cityAreaObj.countryId,
                prefectures: cityAreaObj.prefectures.map(function (prefecture) {
                    return {
                        prefectureId: prefecture.prefectureId,
                        cityIds: prefecture.cityIds,
                    };
                }),
            },
        };
    }
};
var convertFromDeliveryLocationGroup = function (deliveryLocationGroup, isCampaignCreative) {
    var id = deliveryLocationGroup.id, locationGroupId = deliveryLocationGroup.locationGroupId, radius = deliveryLocationGroup.radius, creatives = deliveryLocationGroup.creatives, deleted = deliveryLocationGroup.deleted;
    // 登録しない配信地点は送信しない
    if (id == null && deleted)
        return undefined;
    var withoutCreativeParams = {
        id: id,
        locationGroupId: locationGroupId,
        radius: radius,
        deleted: deleted,
    };
    return isCampaignCreative
        ? withoutCreativeParams
        : __assign(__assign({}, withoutCreativeParams), { creatives: creatives });
};
